/* eslint-disable consistent-return */
import store from '@/store';

/**
 * @override
 * @param {*} to destino
 * @param {*} from origen
 * @param {*} next retorno
 */
export default function (to, from, next) {
    // Si no tiene from es una pestaña/ventana abierta nueva(del navegador) o una recarga de página
    if (!from.name && to.name !== 'login') {
        // Se cargan las pestañas abiertas
        const localS = localStorage.getItem('BOCOYMI');
        let actualSection;
        if (localS) {
            const atoLocalS = atob(localS);
            const scapeAtoLocalS = escape(atoLocalS);
            const decodeScapeAtoLocalS = decodeURIComponent(scapeAtoLocalS);
            const JSONdecodeScapeAtoLocalS = JSON.parse(decodeScapeAtoLocalS);
            // si hay pestañas abiertas
            if (JSONdecodeScapeAtoLocalS.length) {
                // se busca si la que estamos intentando cargar via ruta directamente la teníamos abierta
                actualSection = JSONdecodeScapeAtoLocalS.find(seccion => {
                    let found = false;
                    // Si la ruta a la que queremos navegar tiene parámetros
                    // (por ejemplo, se intenta navegar al detalle de una entidad, ver una cuenta, por ejemplo)
                    if (Object.keys(to.params).length && Object.keys(seccion.route.params).length) {
                        // en este caso se comprueba que la ruta sea la misma y los parámetros también
                        // por ejemplo, que se navegue al detalle de un grupo (to.name = groups_uuid)
                        // y que además, el grupo que se quiera ver sea de los que tenemos en las pestañas
                        // to.params === seccion.route.params
                        // Se `stringifyca` el objeto como ñapilla para comprobar que la ruta sea igual
                        found = JSON.stringify(to.params) === JSON.stringify(seccion.route.params);
                    } else {
                        // si la ruta no tiene parámetros (por ejemplo, el listado de una sección)
                        // se comprueba únicamente el nombre de la ruta
                        found = seccion.route.name.toLowerCase() === to.name;
                    }
                    return found;
                });
            }
        }
        if (actualSection) {
            // Si la sección a la que se accede es una sección de las que teníamos abiertas
            // Se carga esa ruta normalmente, activando el item (pestaña)
            store.dispatch('yuriMenuStore/disableItemsMenu')
                .then(() => {
                    store.dispatch('yuriMenuStore/upsertItem', actualSection)
                        .then(() => {
                            store.dispatch('yuriMenuStore/setActiveItem', actualSection);
                            next();
                        });
                });
        } else if (to.name !== 'dashboard' && to.name !== 'password-reset' && to.name !== 'new-password') {
            // Si a donde navegamos no es algo que tuvieramos abierto
            // y no es el dashboard, password-reset o new-password,
            // se carga el dashboard
            const item = {
                name: 'Dashboard',
                active: true,
                icon: 'fal fa-home',
                route: {
                    name: 'dashboard'
                }
            };
            store.dispatch('yuriMenuStore/disableItemsMenu')
                .then(() => {
                    store.dispatch('yuriMenuStore/setActiveItem', item);
                    next('dashboard');
                });
        } else {
            // En otro caso (esto sería únicamente cuando se cargue el dashboard, password-reset o new-password),
            // simplemente pasamos a la siguiente ruta (dashboard, password-reset o new-password)
            next();
        }
    } else {
        // en caso contrario (navegando normalmente) no se hace nada, pasa a la siguiente ruta
        return next();
    }
}
